// @flow
import * as React from 'react';
import { memoize } from 'lodash';
import { Select } from 'grommet';
import {
    MAX_TIMESTAMP,
    MIN_TIMESTAMP,
} from './DatePicker';


type Props = {
    value: number,
    onChange: (value: number) => void,
    yearsSpan?: number,
    minYear?: number,
    maxYear?: number,
};


class YearPicker extends React.Component<Props> {
    static defaultProps = {
        yearsSpan: 50,
        minYear: new Date(MIN_TIMESTAMP).getFullYear(),
        maxYear: new Date(MAX_TIMESTAMP).getFullYear(),
    };

    constructor(props: Props) {
        super(props);
        this.getOptions = memoize(this.getOptions);
    }

    getOptions = (year: number): Array<string> => {
        const options = [];
        const { yearsSpan } = this.props;

        const maxYearSpan = year + (yearsSpan || YearPicker.defaultProps.yearsSpan);
        const end = this.props.maxYear <= maxYearSpan ? this.props.maxYear : maxYearSpan;

        const minYearSpan = year - (yearsSpan || YearPicker.defaultProps.yearsSpan);
        const start = this.props.minYear >= minYearSpan ? this.props.minYear : minYearSpan;

        for (let y = start; y <= end; y += 1) {
            options.push(y.toString());
        }

        return options;
    };

    handleChange = ({ option }: { option?: number }) => {
        const { onChange, value: propValue } = this.props;
        onChange(option || propValue);
    };

    render() {
        const { value } = this.props;

        return (
            <Select
                options={this.getOptions(value)}
                value={value.toString()}
                onChange={this.handleChange}
                plain
            />
        );
    }
}


export default YearPicker;
